import { render, staticRenderFns } from "./ManageAnnouncements.vue?vue&type=template&id=a6edf3a8&scoped=true"
import script from "./ManageAnnouncements.vue?vue&type=script&lang=ts"
export * from "./ManageAnnouncements.vue?vue&type=script&lang=ts"
import style0 from "./ManageAnnouncements.vue?vue&type=style&index=0&id=a6edf3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6edf3a8",
  null
  
)

export default component.exports